import './style';
import App from './components/app';
import 'preact/debug';

export default App;
